import { render, staticRenderFns } from "./RealPayingTarget.vue?vue&type=template&id=0d6a2266"
import script from "./RealPayingTarget.vue?vue&type=script&lang=js"
export * from "./RealPayingTarget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports